<template>
  <v-layout row justify-center>
    <v-dialog v-model="viewMoreCompetitorsDialog" persistent max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline mr-4">
            <v-icon class="pl-2">more</v-icon>
            מתחרים על מילת המפתח
          </span>
          <v-btn absolute left depressed flat fab small @click="closeModal()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            v-model="selected"
            :items="topCompetitors"
            hide-actions
            class="no-action-table"
            value="domain"
            item-key="domain"
            :loading="loading"
          >
            <template slot="items" slot-scope="props">
              <td>
                {{ props.item.domain ? props.item.domain : '-' }}
              </td>
              <td v-if="searchType === 'keyword'" class="text-xs-center">
                <span v-if="props.item.change > 0" class="keyword-change green--text">
                  <v-icon class="green--text">arrow_drop_up</v-icon>
                  <span>{{ props.item.keywords_count }}</span>
                </span>
                <span v-else-if="props.item.change < 0" class="keyword-change red--text">
                  <v-icon class="red--text">arrow_drop_down</v-icon>
                  <span>{{ props.item.keywords_count }}</span>
                </span>
                <span v-else>-</span>
              </td>
              <td v-if="searchType === 'domain'" class="text-xs-center">
                  <span v-if="props.item.change > 0" class="keyword-change green--text">
                    <v-icon class="green--text">arrow_drop_up</v-icon>
                    <span>+{{ props.item.change }}</span>
                  </span>
                  <span v-else-if="props.item.change < 0" class="keyword-change red--text">
                    <v-icon class="red--text">arrow_drop_down</v-icon>
                    <span>-{{ props.item.change }}</span>
                  </span>
                  <span v-else>-</span>
                </td>
              <td v-if="searchType === 'domain'" class="text-xs-center">
                {{ props.item.common_keywords ? props.item.common_keywords : '-' }}
              </td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap justify-center class="text-xs-center">
            <v-spacer class="xs-d-none"></v-spacer>
            <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'TopCompetotorsBoxModal',
  props: ['viewMoreCompetitorsDialog', 'topCompetitors', 'searchType'],
  data () {
    return {
      // testData: {'data': [{'domain': 'www.d.co.il', 'common_keywords': 9, 'change': 0}, {'domain': 'www.drushim.co.il', 'common_keywords': 9, 'change': 1}, {'domain': 'www.youtube.com', 'common_keywords': 8, 'change': 2}, {'domain': 'www.leos.co.il', 'common_keywords': 7, 'change': 1}, {'domain': 'www.facebook.com', 'common_keywords': 7, 'change': 2}, {'domain': 'www.alljobs.co.il', 'common_keywords': 7, 'change': 0}, {'domain': 'www.hackeru.co.il', 'common_keywords': 7, 'change': -1}, {'domain': 'il.indeed.com', 'common_keywords': 7, 'change': 0}, {'domain': 'successpoint.co.il', 'common_keywords': 6, 'change': -1}, {'domain': 'seoagency.co.il', 'common_keywords': 6, 'change': -1}], 'last_update': '2020-04-20'},
      selected: [],
      loading: false,
      selectedValue: null,
      headers: [
        { text: 'מתחרים', value: 'domain', sortable: false, align: 'right' },
        { text: "מס' מילים משותפות", value: 'keywords_count', sortable: false, align: 'middle', type: 'keyword' },
        // { text: 'Competitors', value: 'domain', sortable: false },
        // { text: 'Number of ranking keywords', value: 'keywords_count', sortable: false, align: 'middle', type: 'keyword' },
        { text: 'שינוי', value: 'change', sortable: false, align: 'middle', type: 'domain' },
        { text: "מס' מילים משותפות", value: 'common_keywords', sortable: false, align: 'middle', type: 'domain' }
        // { text: 'Change', value: 'change', sortable: false, align: 'middle', type: 'domain' },
        // { text: 'Shared keywords', value: 'common_keywords', sortable: false, align: 'middle', type: 'domain' }
      ]
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
    this.headers = this.headers.filter(item => !item.type || item.type === this.searchType)
    // this.topCompetitors = this.testData.data
    // if (this.keyword && (this.engineId || this.engineId === 0)) {
    //   this.getTopCompetitors()
    // }
  },
  watch: {
    // 'viewMoreCompetitorsDialog': function () {
    //   if (this.viewMoreCompetitorsDialog && this.project) {
    //     this.getTopCompetitors()
    //   }
    // }
  },
  computed: {
    projectCompetitorsDomains: function () {
      return this.projectCompetitors ? this.projectCompetitors.map((competitor) => { return competitor.domain }) : []
    }
  },
  methods: {
    // convertCompetitors () {
    //   let arrCompetitors = [...this.projectCompetitorsDomains]

    //   this.selected.map((competitor) => {
    //     if (!arrCompetitors.includes(competitor.domain)) arrCompetitors.push(competitor.domain)
    //   })
    //   arrCompetitors = arrCompetitors.map((competitor) => { return { 'name': competitor, 'domain': competitor, 'subdomains': [] } })
    //   return arrCompetitors
    // },
    // downloadXlsx () {
    //   if (!this.$store.state.user.permissions.is_admin && !this.$store.state.user.permissions.download_xlsx) {
    //     this.$eventEmitter.$emit('showAlert', 'perms', 'You have no access to download xlsx file', 'To get access please upgrade your package')
    //   } else {
    //     this.loading = true
    //     this.$store.dispatch('EXPORT_COMPETITORS', { projectId: this.project.id, engineId: parseInt(this.$route.params.engineId) }).then(res => {
    //       this.saveFile(res)
    //       this.loading = false
    //       this.$toasted.show('Download will start in few seconds')
    //     }, err => {
    //       console.log('EXPORT_COMPETITORS ERROR', err)
    //       this.loading = false
    //       let errorText = this.$services.getApiError(err)
    //       if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
    //     })
    //   }
    // },
    // saveFile (data) {
    //   let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
    //   let link = document.createElement('a')
    //   link.href = window.URL.createObjectURL(blob)
    //   link.download = 'competitors_export.xlsx'
    //   document.body.appendChild(link)
    //   link.click()
    //   document.body.removeChild(link)
    // },
    // getTopCompetitors () {
    //   let params = {
    //     top: 25,
    //     engine_id: parseInt(this.$route.params.engineId)
    //   }
    //   this.loading = true
    //   this.$store.dispatch('GET_TOP_COMPETITORS', { projectId: '', params: params }).then(res => {
    //     this.topCompetitors = res.data
    //     this.selected = this.topCompetitors.filter(competitor => this.projectCompetitorsDomains.includes(competitor.domain))
    //     this.loading = false
    //   }, err => {
    //     this.loading = false
    //     console.log('GET_TOP_COMPETITORS error', err)
    //     let errorText = this.$services.getApiError(err)
    //     if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
    //   })
    // },
    closeModal () {
      this.$parent.$emit('viewMoreCompetitorsDialog', false)
    }
  }
}
</script>

<style scoped>
.competitors-modal-table thead tr th:first-child, .competitors-modal-table tbody tr td:first-child {
  padding: 0 10px;
  width: 45px;
}
.competitors-modal-table thead tr th, .competitors-modal-table tbody tr td {
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/boxes/TopCompetotorsBoxModal.vue